/**
 * +field: screen-edge arrow math for the main quest's waypoint (hud/field/waypoint.ts). Pure.
 */

/** Margin from the screen edge (px) and the bottom band kept clear for the skill bar. */
export const EDGE_MARGIN = 56;
export const BOTTOM_CLEAR = 170;

/**
 * Where the edge arrow sits and which way it points: along the ray from the hero's screen point
 * toward the target's (mirrored when the target is behind the camera), clamped to an inset frame.
 */
export function edgeArrow(hero: { x: number; y: number }, target: { x: number; y: number; visible: boolean }, vw: number, vh: number): { x: number; y: number; angle: number } {
  let dx = target.x - hero.x;
  let dy = target.y - hero.y;
  // Behind the camera the projection flips: point the other way.
  if (!target.visible && target.y > hero.y) {
    dx = -dx;
    dy = -dy;
  }
  if (Math.abs(dx) < 1e-3 && Math.abs(dy) < 1e-3) dy = -1;
  const cx = vw / 2;
  const cy = (vh - BOTTOM_CLEAR) / 2;
  const hw = Math.max(10, vw / 2 - EDGE_MARGIN);
  const hh = Math.max(10, (vh - BOTTOM_CLEAR) / 2 - EDGE_MARGIN);
  const s = Math.min(hw / Math.max(1e-6, Math.abs(dx)), hh / Math.max(1e-6, Math.abs(dy)));
  return { x: cx + dx * s, y: cy + dy * s, angle: Math.atan2(dy, dx) };
}
